import * as React from 'react';
import cx from 'classnames';
import get from 'lodash/get';
import { PriceLineItem } from './PriceLineItem';
import ImageValueWidget from 'components/ImageValueWidget/ImageValueWidget';
import Tooltip from 'components/Tooltip/Tooltip';
import styles from './PriceLineItem.css';
const InfoTooltip = (props) => {
    const { info, label } = props;
    const infoPriceDetails = get(info, 'value.priceDetails');
    const infoIcon = get(info, 'value.infoIcon');
    const infoTitle = get(infoPriceDetails, 'title');
    if (!infoIcon || !infoPriceDetails || !infoTitle) {
        return null;
    }
    const offersList = get(infoPriceDetails, 'offers') || [];
    const labelStr = label === undefined ? '' : String(label);
    const tooltipAnchor = `info-icon-${labelStr.replace(/[^a-zA-Z0-9]/g, '')}`;
    return (<React.Fragment>
			<div id={tooltipAnchor} className={styles['info-icon']}>
				<ImageValueWidget image={infoIcon}/>
			</div>
			<Tooltip anchor={`#${tooltipAnchor}`} theme="light" position="bottom-right" className={cx(styles['info-tooltip'], styles['price-line-info-tooltip'])} containerClassName={styles['info-tooltip-container']}>
				<div className={styles['info-title']}>{infoTitle}</div>
				{offersList.map(offer => {
        const offerLabel = offer.label;
        return offerLabel ? (<PriceLineItem {...offer} text={offerLabel} key={offerLabel} containerClassName={styles['price-line-item']}/>) : null;
    })}
			</Tooltip>
		</React.Fragment>);
};
export default InfoTooltip;
